// src/services/secureLinkApi.js
import axios from "axios";
import { getCookie } from "../utils/auth";
import { getDeviceFingerprint } from "../utils/device"; // <--- 1. IMPORT THIS

let BASE = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";
BASE = BASE.replace(/\/+$/, "");

if (BASE.endsWith("/api")) {
  BASE = BASE + "/v1";
} else if (!BASE.endsWith("/api/v1")) {
  BASE = BASE + "/api/v1";
}

const API_URL = `${BASE}/college`;

export const secureLinkApi = {
  generateSecureLink: async (purpose, collegeId = null) => {
    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("userToken") ||
      getCookie("auth_token") ||
      getCookie("token");

    if (!token) {
      throw new Error("College user not logged in");
    }

    // 2. GENERATE DEVICE ID HERE
    const deviceId = getDeviceFingerprint(); 

    const payload = { purpose };
    if (collegeId) payload.collegeId = collegeId;

    const res = await axios.post(
      `${API_URL}/secure-links`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-Device-ID": deviceId, // <--- 3. ADD THIS HEADER
        },
        withCredentials: true,
      }
    );

    return res.data;
  },
};